
import React, { useState } from 'react'
import { useNavigate } from "react-router-dom";
import { Box, Grid, Stack, Typography, IconButton, CircularProgress } from '@mui/material';
import { useDispatch, useSelector } from "react-redux";
// icons
import VisibilityIcon from '@mui/icons-material/Visibility';
// utils and helpers
import { formatTimestampToWithoutTime } from "utilities/common";
import { createRefillKit, deleteRefillList, getRefillListing, testRefillKit } from "../../../redux/slices/hyperwolf/inventoryDistribution";
// custom components
import CommonLayout from 'layouts/DashboardLayout'
import MDButton from 'components/MDButton';
import AgGridAccordionTable from "components/tables/AgGridAccordionTable";
import { showToastMsg } from "../distributionManagement/addRegionKit";
import { DateFilter } from "common/filters";
import { openCustomModalDialog, setModalLoader } from '../../../redux/slices/modalSlice';
import { closeCustomModalDialog } from '../../../redux/slices/modalSlice';
import DeleteIcon from "common/customIcons/delete";
import LoopIcon from '@mui/icons-material/Loop';
import { getPermissionsByMode } from 'utilities/common';
import { hasSectionPermission } from 'utilities/common';
import { getData } from 'utilities/common';

const RefillLogs = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate();
  const { isRefilling } = useSelector(state => state.inventoryDistribution)

  const [refreshTable, setRefreshTable] = useState(false)
  const [customFilters, setCustomFilters] = useState({});

  const columnDefs = [
    {
      headerName: 'Distribution Date',
      field: 'distributionDate',
      suppressMenu: false,
      minWidth: 400,
      sortable: false,
      className: 'field-region',
      valueGetter: ({ data }) => `${formatTimestampToWithoutTime(data?.distributionDate)}`
    },
    // {
    //     headerName: 'Retail Value',
    //     field: 'retailerValue',
    //     suppressMenu: false,
    //     sortable: false,
    //     className: 'field-opening-hour',
    //     valueGetter: ({ data }) => data.retailerValue ? `$${data.retailerValue?.toLocaleString() || 0}` : 0
    // },
    {
      headerName: 'Kit Value',
      field: 'wholesaleValue',
      suppressMenu: false,
      sortable: false,
      className: 'field-closing-hour',
      valueGetter: ({ data }) => data.wholesaleValue ? `$${data.wholesaleValue?.toLocaleString() || 0}` : 0
    },
    {
      headerName: 'Refill Qty',
      field: 'addRefilled',
      suppressMenu: false,
      sortable: false,
      className: 'field-status',
    },
    {
      headerName: 'Actions',
      cellRenderer: ({ data = {} }) => {
        return <Box display="flex" flexDirection="row" justifyContent="end" gap={0.5}>
          {
            // data?.status === "Splitting Finished" &&
            <>
              <IconButton onClick={() => navigate(`/hyperwolf/refill-logs/${data.refillId}?distributionId${data?.distributionId}&date=${data?.distributionDate}`)} color='primary' size='small' variant='primary'>
                <VisibilityIcon width='16px' height='16px' />
              </IconButton>
              <IconButton
                color='error'
                size='small'
                variant='primary'
                onClick={(e) => {
                  e.stopPropagation();
                  dispatch(openCustomModalDialog({ modalData: { deleteHandler, deleteId: data.refillId }, modal: 'DELETE_MODAL' }))
                }}
              >
                <DeleteIcon width='16px' height='16px' />
              </IconButton>
            </>
          }
        </Box>
      },
      cellStyle: { textAlign: 'right', justifyContent: 'end' },
      headerClass: 'right-aligned-cell-header',
      maxWidth: 100,
      pinned: 'right',
      className: 'field-actions'
    },
  ];

  const expandedColumnDefs = [
    {
      headerName: 'Regions',
      field: 'region',
      suppressMenu: false,
      flex: 1.5,
      minWidth: 220,
      sortable: false
    },
    {
      headerName: 'Sub Regions',
      field: 'subRegions',
      suppressMenu: false,
      flex: 1.5,
      minWidth: 240,
      sortable: false,
      valueGetter: ({ data = {} }) => data.subRegions?.length ? data.subRegions?.join(", ") : "-"
    },
    {
      headerName: 'Total Products',
      field: 'totalProducts',
      suppressMenu: false,
      flex: 0.75,
      minWidth: 100,
      sortable: false,
    },
    // {
    //     headerName: 'Total Retail Amount',
    //     field: 'totalRetailAmount',
    //     suppressMenu: false,
    //     flex: 1.25,
    //     minWidth: 180,
    //     sortable: false,
    //     valueGetter: ({ data }) => data.totalRetailAmount ? `$${data.totalRetailAmount?.toLocaleString()}` : "-"
    // },
    {
      headerName: 'Total Kit Value',
      field: 'totalWholesaleAmount',
      suppressMenu: false,
      flex: 0.75,
      minWidth: 100,
      sortable: false,
      cellStyle: { textAlign: 'right', justifyContent: 'end' },
      headerClass: 'right-aligned-cell-header',
      valueGetter: ({ data }) => data.totalWholesaleAmount ? `$${data.totalWholesaleAmount?.toLocaleString()}` : "-"
    },
  ];

  const handleCreateRefill = async () => {
    if (isRefilling) return;
    try {
      const response = await dispatch(createRefillKit({})).unwrap();
      if (response) {
        showToastMsg(response?.message, "success")
        setRefreshTable(prev => !prev)
      }
    } catch (error) {
      showToastMsg(error, "error")
    }
  }

  const handleTestRefill = async () => {
    if (isRefilling) return;
    try {
      // const response = await dispatch(testRefillKit({})).unwrap();
      // if (response) {
      //   showToastMsg(response?.message, "success")
      //   await handleCreateRefill();
      // }
      await handleCreateRefill();
    } catch (error) {
      showToastMsg(error, "error")
    }
  }

  const handleDateChange = async (values) => {
    setCustomFilters(prev => ({ ...prev, ...values }));
    setRefreshTable(prev => !prev)
  }

  const deleteHandler = (refillId) => {
    dispatch(setModalLoader(true));
    dispatch(deleteRefillList(refillId)).unwrap().then((res) => {
      showToastMsg(res?.message, 'success');
      dispatch(closeCustomModalDialog());
      setRefreshTable(!refreshTable)
    }).catch((err) => {
      dispatch(setModalLoader(false));
      showToastMsg(err?.message, 'error');
    });
  }

  let localUser = getData("login-user-info");
  if (localUser) {
    localUser = JSON.parse(localUser);
  }

  const adminMode = localStorage.getItem("adminsMode")
    ? JSON.parse(localStorage.getItem("adminsMode"))
    : null;
  const permissionsForMode = getPermissionsByMode(localUser?.permissions, adminMode);
  const canCreate = hasSectionPermission(permissionsForMode, "Inventory Distribution", "Create");
  const canView = hasSectionPermission(permissionsForMode, "Inventory Distribution", "View Only");
  const canDelete = hasSectionPermission(permissionsForMode, "Inventory Distribution", "Delete");
  const canEdit = hasSectionPermission(permissionsForMode, "Inventory Distribution", "Edit/Update");

  return (
    <CommonLayout>
      <Box p={{ xs: 2, sm: 3, lg: 4 }}>
        <Grid container alignItems="center" rowSpacing={2} columnSpacing={2} mb={3}>
          <Grid item xs={12} sm={4}>
            <Typography variant='h4' fontWeight="semibold">Kit Replenishment Logs</Typography>
          </Grid>

          <Grid item xs={12} sm={8}>
            <Stack direction="row" justifyContent={{ xs: 'start', sm: 'end' }} flexWrap="wrap" alignItems="stretch" gap={2} className="btn-filter-icon">
              {/* Date Filter */}
              <DateFilter handleChange={handleDateChange} />

              {/* Add button */}
              <MDButton
                style={{ height: "100%", minWidth: "160px", minHeight: "47px", gap: "6px" }}
                variant="contained"
                color="primary"
                onClick={handleTestRefill}
                disabled={isRefilling}
              >
                {isRefilling ? <CircularProgress size={20} color="light" /> : <><LoopIcon style={{ width: "22px", height: "22px" }} /> Test Refill Kit</>}
              </MDButton>
              {/* <MDButton
                  style={{ height: "100%", minWidth: "160px", minHeight: "47px", gap: "6px" }}
                  variant="contained"
                  color="primary"
                  onClick={handleCreateRefill}
              >
                  {isRefilling ? <CircularProgress size={20} color="light" /> : <><LoopIcon style={{ width: "22px", height: "22px" }} /> Refill Kit</>}
              </MDButton> */}
            </Stack>
          </Grid>
        </Grid>

        {/* Listing */}
        <div className="w-100 cus-four-columns">
          <AgGridAccordionTable
            tableName="Refill logs"
            columnDefs={columnDefs}
            expandedColumnDefs={expandedColumnDefs}
            getDataMethod={getRefillListing}
            refreshTable={refreshTable}
            customFilters={customFilters}
          />
        </div>
      </Box>
    </CommonLayout>
  )
}

export default RefillLogs
